export const AutomationEmail = {
  scenario_id: null,
  email_subject: {
    en: '',
    de: ''
  },
  email_content: {
    en: '',
    de: ''
  },
  trigger_at_days_before: 5
}